import React, { useContext} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import IdTokenContext from "../../auth/IdTokenContext";

const LogoutButton = () => {
    const { clearIdToken } = useContext(IdTokenContext);
    const { logout } = useAuth0();
    // const { nickname } = user || {};

    return (
        <div className="loginContainer">
            <button
                className="btn btn-danger"
                onClick={() => {
                    clearIdToken?.();
                    logout({ logoutParams: { returnTo: window.location.origin } })
                }
                }>
                Log Out
                {/* {nickname} */}
            </button>
        </div>
    );
};

export default LogoutButton;